import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from '@totvsmoda/core';

export const AppRoutes: Routes = [   
    {
        path: "home",
        canActivate: [AuthGuard],
        loadComponent: () =>
            import('./home/home.component').then((x) => x.HomeComponent)
    },
    {
        path: "",
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./module/pcp/pcp.routes').then((x) => x.PcpRoutes)    
    },
    {
        path: "**",
        redirectTo: "blocked"
    },
];